export default __webpack_public_path__ + "static/media/offer.43a3e964.png";